var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import TaskService from "../../../Services/Task.service";
import TaskUpdateForm from "./TaskUpdateForm";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import useUniqueId from "../../Hooks/useUniqueId";
const TaskUpdateModal = (_a) => {
    var { task, onUpdated } = _a, modalProps = __rest(_a, ["task", "onUpdated"]);
    const makeId = useUniqueId()[1];
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { defaultValue: { status: task.status }, respondToDefaultValueChanges: true, modalTitle: "Update Task", handleSubmit: (formVals) => {
            var _a;
            return TaskService.updateTaskStatus(task.id, formVals.status.id, {
                notifyPersonIds: (_a = formVals.peopleToNotify) === null || _a === void 0 ? void 0 : _a.map((person) => person.personId),
                comment: formVals.comment,
            }).then(onUpdated || (() => null));
        }, children: (formProps) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("breadcrumb"), children: "Task" }), _jsxs("ol", { className: "breadcrumb py-1", id: makeId("breadcrumb"), children: [task.actionPlanTitle && (_jsx("li", { className: "breadcrumb-item", children: _jsx("a", { children: task.actionPlanTitle }) })), _jsx("li", { className: "breadcrumb-item", children: task.title })] })] }), _jsx(TaskUpdateForm, Object.assign({}, formProps, { oldTaskStatusId: task.status.id }))] })) })));
};
export default TaskUpdateModal;
